import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementAd from '@/components/ads/ElementAd.vue';
import VueYouTubeEmbed from 'vue-youtube-embed';
import moment from 'moment';
import Client from '@/client';
import VueFeather from 'vue-feather';
import {
	Swiper as SwiperClass,
	Pagination,
	Mousewheel,
	Navigation,
	Autoplay,
	Controller,
} from 'swiper/core';
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter';
import 'swiper/swiper-bundle.css';
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';
import { should_use_v2_api } from './helpers';
SwiperClass.use([Pagination, Mousewheel, Navigation, Autoplay, Controller]);
Vue.use(getAwesomeSwiper(SwiperClass));
Vue.use(VueYouTubeEmbed);
Vue.use(VueFeather);
Vue.use(VuePlyr, {
	plyr: {},
});
Vue.prototype.moment = moment;
Vue.config.productionTip = false;
Vue.prototype.window = window;
Vue.config.devtools = true;

Vue.component('ElementAd', ElementAd);

new Vue({
	data: {
		dark_mode: false,
		signing_day: null,
		roster: [],
		selected_components: [],
		navigation: null,
		active_component: null,
	},
	methods: {
		get_data() {
			var data;
			if (process.env.VUE_APP_IN_DEV_MODE) {
				data = this.get_data_from_api();
			} else {
				data = this.get_data_from_window();
			}
			data.then(data => {
				this.signing_day = data;
				this.dark_mode = data.dark_mode;
				if (
					data.colors &&
					Object.keys(data.colors).length != 0 &&
					data.colors.constructor === Object
				) {
					var school_colors = data.colors;

					document.documentElement.style.setProperty(
						'--color-primary',
						school_colors.primary_background,
					);
					document.documentElement.style.setProperty(
						'--color-safe-text-on-light',
						school_colors.safe_text_on_white,
					);
					document.documentElement.style.setProperty(
						'--color-safe-text-on-dark',
						school_colors.safe_text_on_black,
					);
					document.documentElement.style.setProperty(
						'--text-on-primary',
						school_colors.primary_text,
					);
					document.documentElement.style.setProperty(
						'--color-secondary',
						school_colors.secondary_background,
					);
					document.documentElement.style.setProperty(
						'--text-on-secondary',
						school_colors.secondary_text,
					);
				}

				if (data.selectedComponents && data.selectedComponents.length) {
					this.selected_components = data.selectedComponents.filter(
						component => {
							return component.name != 'navigation';
						},
					);

					let _navigation = data.selectedComponents.filter(
						component => {
							return component.name === 'navigation';
						},
					);

					if (_navigation.length) {
						this.navigation = _navigation[0];
					}
				}

				let roster = data.selectedComponents.filter(x => {
					return x.name === 'roster';
				})[0];

				let _data = roster.selectedPlayers;
				this.roster = _data;
			}).catch(err => {
				console.error(err);
			});
		},
		get_data_from_api() {
			window.signingday_id = process.env.VUE_APP_SIGNINGDAY_ID;
			if (!window.signingday_id) {
				return Promise.reject('Failed to get gameday');
			}
			// return Client.get(`/services/signingday.ashx?type=get-signingday&id=8`, {
			return should_use_v2_api()
				? this.fetch_from_v2_api()
				: this.fetch_from_legacy_api();
		},
		fetch_from_legacy_api() {
			return Client.get(
				`/services/signingday.ashx?type=get-signingday&id=${window.signingday_id}`,
				{
					headers: {
						'Access-Control-Allow-Origin': '*',
						'Content-type': 'application/json',
					},
				},
			).then(response => {
				if (response && response.data) {
					return response.data;
				}
				throw new Error('Failed to get signing day from legacy API.');
			});
		},
		fetch_from_v2_api() {
			return Client.get(
				`/api/v2/SigningDay?signingDayId=${window.signingday_id}&useLegacyPropertyNames=true`,
			).then(response => {
				if (response && response.data) {
					return response.data;
				}
				throw new Error('Failed to get signing day from v2 API.');
			});
		},
		get_data_from_window() {
			return new Promise((resolve, reject) => {
				if (window.signingday) {
					return resolve(window.signingday);
				}
				return reject('Signing Day not found');
			});
		},
	},
	watch: {
		dark_mode: function(val) {
			if (val)
				document.documentElement.setAttribute('data-theme', 'dark');
		},
	},
	created() {
		this.get_data();
	},
	router,
	render: h => h(App),
}).$mount('#app');
